import router from '../router'
import { getStore, keys } from '../store'

export function LoginRedirect() {
    let redirect = getStore(keys.redirect);
    let user = getStore(keys.user)
    if (user.user_info.member_status==0) {
        if (redirect) {
            router.push(redirect);
        }else{
            router.push({ path: '/' });
        }
    } else router.push({ path: '/plan-information' });
}


// WEBPACK FOOTER //
// ./src/services/redirectService.js